import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react'
import cancelemailicon from "../../components/header/images/cancelemail.svg";
import validateEmail from "../../utilities/validateEmail";
import { NotificationManager } from "react-notifications";
import powerResumeSharingResponse from "../../apis/sharePoweResume/powerResumeSharing";
import sharePoweResumeResponse from "../../apis/sharePoweResume/sharePoweResume";
const jsonConfig = require("../../Config.json");

const SharePowerResume = (props) => {

    const { userType, userRecords, userId, modalForShare, setmodalForShare, candidateId, candidateEmailId} = props;

    // const [modalForShare, setmodalForShare] = useState(false);
    const [mailInput, setMailInput] = useState("");
    const [allmailforshare, setallmailforshare] = useState([]);
    const [errorEmailMessage, setErrorEmailMessage] = useState(false);
    const [showmail, setshowmail] = useState(true);
    const [count, setcount] = useState(0)
    const [maillength, setmaillength] = useState(0)
    const [value, setValue] = useState("");
    const [sharedMessage, setSharedMessage] = useState("");
    const filter = createFilterOptions();

    var tempCount = 0;
    var mailct = allmailforshare.length;

    const mailopen = () => {
        setshowmail(true);
    }

    const handelcloseshare = () => {
        setMailInput("");
        setmodalForShare(false);
        setallmailforshare([]);
        setErrorEmailMessage(false);
    };

    const emailCheak = () => {
        var tempo = allmailforshare.length;
        let countEmail = count + mailInput.length + 10;
        setcount(countEmail)
        if (countEmail > 80) {
            setshowmail(false)
        }
        else {
            setmaillength(tempo)
        }
    }

    const handleReset = () => {
        setValue("");
    };
    const deleteEmailHandler = (i) => {
        if (i > -1) {
            allmailforshare.splice(i, 1);
        }
        setallmailforshare((prev) => [...prev])
        allmailforshare.forEach((value) => { tempCount = tempCount + value.length; });
        tempCount = tempCount + ((mailct - 1) * 10)
        if (tempCount > 80) {
            setcount(tempCount)
        }
        else {
            setmaillength(mailct - 2)
        }
        setcount(tempCount)
    };
    const addEmailHandler = async (value) => {
        const mailAddress = mailInput;
        const local_email = validateEmail(mailInput);
        setValue(value)
        if (
            local_email &&
            (mailAddress.includes("gmail") ||
                mailAddress.includes("outlook") ||
                mailAddress.includes("yahoo") ||
                mailAddress.includes("hotmail"))
        ) {
            NotificationManager.error(`you can only share PoweResume to a corporate email address`,
                "Error", 10000);
        }
        else if (local_email) {

            var temp = 0;
            for (var i = 0; i <= allmailforshare.length; i++) {
                if (mailInput === allmailforshare[i]) {
                    temp++;
                }
            }
            if (temp === 0) {
                emailCheak();
                await setallmailforshare((prev) => [...prev, mailInput]);
            }
            else {
                NotificationManager.error("Email Already Exist ", "Error", 10000);
            }
            setMailInput("");
            handleReset();
        } else {
            NotificationManager.error("Please Enter Correct Email", "Error", 10000);
        }
    };

    const mailclose = () => {
        setshowmail(false);
    }

    const messageHandler = (e, value) => {
        mailclose();
    }
    const sharePoweResumeEmail = async () => {
        const candidateComments = sharedMessage;
        const pathNameSplit = window.location.pathname.split("/");
        const recruiterId = pathNameSplit[2] === "shared" ? "" : userId;

        if (allmailforshare.length === 0) {
            NotificationManager.error(`Please enter valid corporate email address and click  "${"Enter"}"`, "Error", 10000);
            return;
        }

        if (!candidateComments && userType === "Candidate") {
            NotificationManager.error("Enter your message to recruiters/hiring managers", "Error", 10000);
            return;
        }

        if (userType === "Candidate") {
            if (!jsonConfig.sendEmail) {
                NotificationManager.error("Enter atleast one email address and a message", "Error", 10000);
                return;
            }
            try {
                let payload = {
                    ProfileId: candidateId,
                    EmailIDs: allmailforshare,
                    comments: candidateComments,
                    createdBy: userRecords?.id,
                    updatedBy: userRecords?.id,
                    candidateEmailId: candidateEmailId
                };
                const shareResumeResponse = await sharePoweResumeResponse(payload);
                setmodalForShare(false);
                setallmailforshare([]);
                let mailShare = shareResumeResponse?.data?.alreadyAddedRecruiter
                    ? allmailforshare.filter((x) => !shareResumeResponse.data.alreadyAddedRecruiter.includes(x))
                    : allmailforshare;

                if (mailShare.length > 0) {
                    NotificationManager.success(` Your Poweresume has been shared with :-  ` + mailShare.map((x) => x + '\n'), "Success", 10000);
                } else {
                    NotificationManager.error(` You have already shared your Poweresume with :-  ` + shareResumeResponse.data.alreadyAddedRecruiter.map((x) => x + '\n'), "Error", 10000);
                }
            } catch (err) {
                console.log(err);
                NotificationManager.error("Error sending email. Please try again after some time.", "Error", 10000);
            }
        } else {
            try {
                let payload = {
                    recruiterId: recruiterId,
                    ProfileId: candidateId,
                    EmailIDs: allmailforshare,
                    Iscandidate: false,
                    comments: candidateComments,
                    createdBy: recruiterId,
                    updatedBy: recruiterId,
                    candidateEmailId: candidateEmailId
                };
                await powerResumeSharingResponse(payload);
                setmodalForShare(false);
                setallmailforshare([]);
                NotificationManager.success("This PoweResume has been shared", "Success", 10000);
            } catch (err) {
                console.log(err);
                NotificationManager.error("Error sending email. Please try again after some time.", "Error", 10000);
            }
        }
    };


    return (
        <>
            <Dialog
                open={modalForShare}
                onClose={handelcloseshare}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle className="support_dialog_title">
                    <p id="para">Share this </p>
                    <div className="support_lin">PoweResume</div>
                </DialogTitle>

                <DialogContent className="support_con">
                    <div className="">
                        <Grid container className="">
                            <Grid size={{ xs: 12 }}>
                                <div className="support_form_leb mt_18 mb_3 profile_support">
                                    Add Email Id*
                                </div>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                {allmailforshare.map((value, i) =>
                                    showmail ? (
                                        <span className="mail_bg ">
                                            <span className="mail_txt">{value.toLowerCase()}</span>
                                            <span className="mail_close_icon cp">
                                                <img
                                                    src={cancelemailicon}
                                                    onClick={(e) => deleteEmailHandler(i)}
                                                    alt='img'
                                                    height="10px"
                                                    width="10px"
                                                />
                                            </span>
                                        </span>
                                    ) :
                                        (
                                            (maillength + 1) > i ?
                                                (

                                                    <span className="mail_bg">
                                                        <span className="mail_txt">{value.toLowerCase()}</span>
                                                        <span className="mail_close_icon cp">
                                                            <img
                                                                src={cancelemailicon}
                                                                onClick={(e) => deleteEmailHandler(i)}
                                                                height="10px"
                                                                width="10px"
                                                                alt='img'
                                                            />
                                                        </span>
                                                    </span>
                                                ) : (
                                                    <div onClick={mailopen} className="mail_more">
                                                        {i === (maillength + 1) ?
                                                            (
                                                                <span className="mail_b" >
                                                                    <span className="cp">{(allmailforshare.length - 1) - maillength}{" more"}</span>
                                                                </span>
                                                            )
                                                            : ("")
                                                        }
                                                    </div>
                                                )
                                        )
                                )}

                                <Autocomplete
                                    id="tags-filled"
                                    options={[]}
                                    disableClearable
                                    className="mt_10"
                                    freeSolo
                                    value={value}
                                    getOptionLabel={(option) => {
                                        if (typeof option === "string") {
                                            return option;
                                        }
                                        if (option.inputValue) {
                                            return option.inputValue;
                                        }
                                    }}
                                    filterSelectedOptions
                                    filterOptions={(options, params) => {
                                        const filtered = filter(options, params);
                                        if (params.inputValue !== "") {
                                            filtered.push({
                                                inputValue: params.inputValue,
                                                title: params.inputValue,
                                            });
                                        }
                                        return filtered;
                                    }}
                                    onChange={() => addEmailHandler()}
                                    renderOption={(props, option) => (
                                        <li  {...props} className="cp ml_20">{option.inputValue || option.title || option}</li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            className="header-mail-textfield"
                                            value={mailInput}
                                            onChange={(e) => setMailInput(e.target.value.trim())}
                                            placeholder="Add Mail"
                                        />
                                    )}
                                />

                            </Grid>
                            <Grid size={{ xs: 12 }} className="support_grid_message">
                                <div className="support_form_leb mb_10">Add a message{userType === "Candidate" && "*"}</div>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <textarea
                                    type="text"
                                    className="support_message"
                                    rows={4}
                                    onChange={(e) => setSharedMessage(e.target.value)}
                                    onClick={messageHandler}
                                />
                                {errorEmailMessage ? (
                                    <p className="form-error fs-regular">
                                        Please enter a message
                                    </p>
                                ) : (
                                    ""
                                )}
                            </Grid>
                        </Grid>
                    </div>
                </DialogContent>

                <DialogActions className="header-support-dialog-buttons">
                    <Button className="header-btn-cancel" onClick={handelcloseshare}>Cancel</Button>
                    <Button className="header-btn-save" onClick={sharePoweResumeEmail}>Share</Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

export default SharePowerResume
